import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { StyledIconWrapper } from './IconWrapper.styles.js';

const IconWrapper = forwardRef((props, ref) => {
    const { children, id, title, height, width, onClick, svgFillColor, strokeColor, gap, rotate, } = props;
    return (jsx(StyledIconWrapper, Object.assign({ title: title, id: id, height: height, width: width, onClick: onClick, svgFillColor: svgFillColor, gap: gap, rotate: rotate, strokeColor: strokeColor }, { children: children })));
});

export { IconWrapper as default };
//# sourceMappingURL=IconWrapper.js.map
